import React from "react";

import Wrapper from "./wrapper";

const url =
  "https://firebasestorage.googleapis.com/v0/b/collegiate-composites.appspot.com/o/example-photos%2F%%FILE%%.jpg?alt=media";
const example = (file) => url.replace("%%FILE%%", file);

export default ({ onClickNext }) => (
  <Wrapper
    button="Give the camera a little sass, check"
    onClickNext={onClickNext}
  >
    <div className="grid gap-2 grid-cols-2">
      <img
        src={example("BodyTilt_Bad")}
        alt=""
        className="mx-auto"
        style={{ maxHeight: 280 }}
      />
      <img
        src={example("BodyTilt_Good")}
        alt=""
        className="mx-auto"
        style={{ maxHeight: 280 }}
      />
    </div>

    <ul className="mt-6 text-sm leading-6">
      <li className="mb-4 flex">
        <div>✓</div>
        <div className="flex-1 ml-2">
          Stand with your body angled slightly away from the camera.
        </div>
      </li>
      <li className="mb-4 flex">
        <div>✓</div>
        <div className="flex-1 ml-2">
          If the camera is at 12 o'clock, your shoulders should be facing 1
          o'clock.
        </div>
      </li>
      <li className="mb-4 flex">
        <div>✓</div>
        <div className="flex-1 ml-2">
          Turn your head and look straight at the camera.
        </div>
      </li>
    </ul>
  </Wrapper>
);
